import { createSlice } from '@reduxjs/toolkit';
import appTypes from '../app/types';
const initialState = {
    isModalVisible: false,
    showRatePopup: false,
    currentRate: null,
    currentTriggerAction: null,
    firstOpenedAt: null,
    lastOpenedAt: null,
    totalOpens: 0,
    totalContactRevealsCount: null,
    latestFeedback: null,
    enrollments: {
        items: [],
        isLoaded: false,
        isLoading: false,
    },
};
const slice = createSlice({
    name: 'USER_ACTIVITY',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        setActivity(state, { payload }) {
            state.firstOpenedAt = (payload === null || payload === void 0 ? void 0 : payload.firstOpenedAt) || null;
            state.lastOpenedAt = (payload === null || payload === void 0 ? void 0 : payload.lastOpenedAt) || null;
            state.totalOpens = (payload === null || payload === void 0 ? void 0 : payload.totalOpens) || 0;
            state.showRatePopup = (payload === null || payload === void 0 ? void 0 : payload.showRatePopup) || false;
            state.latestFeedback = (payload === null || payload === void 0 ? void 0 : payload.latestFeedback) || null;
            state.totalContactRevealsCount = (payload === null || payload === void 0 ? void 0 : payload.totalContactRevealsCount) || 0;
        },
        setLatestFeedback(state, { payload }) {
            state.latestFeedback = payload || null;
        },
        setModalVisible(state, { payload }) {
            state.isModalVisible = payload;
            if (!payload) {
                state.currentRate = null;
                state.currentTriggerAction = null;
            }
        },
        setCurrentRate(state, { payload }) {
            state.currentRate = payload;
        },
        setCurrentTriggerAction(state, { payload }) {
            state.currentTriggerAction = payload;
        },
        enrollmentsFetchStarted(state) {
            state.enrollments = { items: [], isLoaded: false, isLoading: true };
        },
        enrollmentsFetchSucceeded(state, { payload }) {
            state.enrollments = { items: payload, isLoaded: true, isLoading: false };
        },
        enrollmentsFetchFailed(state) {
            state.enrollments.isLoading = false;
        },
        /** One enrollment per type: replaces the existing entry for `payload.enrollmentType`, or appends. */
        upsertEnrollment(state, { payload }) {
            const existingIndex = state.enrollments.items.findIndex(enrollment => enrollment.enrollmentType === payload.enrollmentType);
            if (existingIndex >= 0) {
                state.enrollments.items[existingIndex] = payload;
            }
            else {
                state.enrollments.items.push(payload);
            }
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
